import API from '@/service/api'

const state = {
  shopUploadEntries: [],
  shopUploadEntry: {},
}

const mutations = {
  UPDATE_SHOPUPLOAD_ENTRIES(state, payload) {
    state.shopUploadEntries = payload
  },

  UPDATE_SHOPUPLOAD_ENTRY(state, payload) {
    state.shopUploadEntry = payload
  },
}

const actions = {
  getShopUploadEntries({ commit }) {
    return API()
      .get('/shop-uploads')
      .then(response => {
        commit('UPDATE_SHOPUPLOAD_ENTRIES', response.data)
      })
  },
  getShopUploadEntriesById({ commit }, id) {
    return API()
      .get(`/shop-uploads/${id}`)

      .then(response => {
        commit('UPDATE_SHOPUPLOAD_ENTRY', response.data)
      })
  },

  addShopUploadEntries({ commit }, payload) {
    return API()
      .post('/shop-uploads', payload)
      .then(response => {
        commit('UPDATE_SHOPUPLOAD_ENTRIES', response.data)
        return response.data
      })
      .catch(error => error)
  },

  deleteShopUploadEntries({ commit }, id) {
    API()
      .delete(`/shop-uploads/${id}`)
      .then(response => {
        commit('UPDATE_SHOPUPLOAD_ENTRIES', response.data)
      })
  },
}

const getters = {
  shopUploadEntries: state => state.shopUploadEntries,
  shopUploadById: state => id =>
    state.shopUploadEntries.find(
      shopUploadEntries => shopUploadEntries.id === id
    ),
  // Check if any entry has a non-null offer
  hasOffer: state =>
    state.shopUploadEntries.some(
      entry => entry.offer !== null && entry.offer !== undefined
    ),
}

const attachmentModule = {
  state,
  mutations,
  actions,
  getters,
}

export default attachmentModule
